import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionService {
    /**
     * Get a company's subscription
     * @returns SubscriptionBoInterface
     * @throws ApiError
     */
    static subscriptionGetSubscription() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscription',
        });
    }
    /**
     * Create a stripe checkout session url
     * @param requestBody
     * @returns SubscriptionCheckoutBoInterface
     * @throws ApiError
     */
    static subscriptionCreateCheckout(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subscription/checkout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate a preview invoice for a subscription quantity change
     * @param requestBody
     * @returns SubscriptionInvoicePreviewBoInterface
     * @throws ApiError
     */
    static subscriptionCreateSubscriptionInvoicePreview(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subscription/invoice/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a subscription's quantity
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    static subscriptionUpdateSubscriptionQuantity(requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/subscription/quantity',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * retrieve a customer portal session url
     * @returns SubscriptionCheckoutBoInterface
     * @throws ApiError
     */
    static subscriptionGetCustomerPortal() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscription/portal',
        });
    }
}
